<div class="signIn-section">
  <div class="signIn-container">
    <div class="signIn-upper-section">
      <span class="signIn-title-text">Register to dp</span>
      <div class="signInin-field-section">
        <form [formGroup]="signInForm">
          <!--2 input boxex-->
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">First Name*</span>
                <input type="text" class="input-field dp-input-control" placeholder="Enter your first name"
                  formControlName="firstName" (keydown)="restrictNameInput($event)" />
              </div>
              @if(
              signInForm.get('firstName')?.invalid&&signInForm.get('firstName')?.touched
              ||inValid){
              <span class="error-text">Enter first name</span>
              }
            </div>
            <div class="col-12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">Last Name*</span>
                <input type="text" class="input-field dp-input-control" placeholder="Enter your first name"
                  formControlName="lastName" (keydown)="restrictNameInput($event)" />
              </div>
              @if( signInForm.get('lastName')?.invalid &&
              signInForm.get('lastName')?.touched){
              <span class="error-text">Enter last name</span>
              }
            </div>
          </div>
          <!--2 input boxex-->
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">Contact Number *</span>
                <input class="input-field dp-input-control" placeholder="Enter your phone number"
                  formControlName="contactNumber" (keydown)="restrictContactInput($event)" />
              </div>
              @if( signInForm.get('contactNumber')?.invalid &&
              signInForm.get('contactNumber')?.touched){
              <span class="error-text">Enter contact number</span>
              }
            </div>
            <div class="col-12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">Email address *</span>
                <input type="text" class="input-field dp-input-control" placeholder="Enter your email address"
                  formControlName="email" (keydown)="restrictEmailInput($event)" />
              </div>
              @if( signInForm.get('email')?.invalid &&
              signInForm.get('email')?.touched){
              <span class="error-text">Enter valid email</span>
              }
            </div>
          </div>
          <!--2 input boxex-->
          <div class="row">
            <div class="col12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">Create password *</span>
                <input [type]="isPasswordVisible ? 'text' : 'password'" class="input-field dp-input-control"
                  placeholder="Enter a password" formControlName="password" (copy)="$event.preventDefault()"
                  (paste)="$event.preventDefault()" (cut)="$event.preventDefault()"
                  (keydown)="restrictConfirmPasswordInput($event)" />
                <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
                  <i [class]="
                      isPasswordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'
                    "></i>
                </button>
              </div>
              @if( passwordInvalid &&
              signInForm.get('password')?.touched){
              <span class="error-text">Password complexity is not matching</span>
              }
            </div>
            <div class="col-12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">Confirm password *</span>
                <input [type]="isConfirmPasswordVisible ? 'text' : 'password'" class="input-field dp-input-control"
                  placeholder="Re-enter password" formControlName="reEnterPassword"
                  (keydown)="restrictConfirmPasswordInput($event)" (copy)="$event.preventDefault()"
                  (paste)="$event.preventDefault()" (cut)="$event.preventDefault()" />
                <button type="button" class="toggle-password" (click)="toggleConfirmPasswordVisibility()">
                  <i [class]="
                      isConfirmPasswordVisible
                        ? 'fas fa-eye'
                        : 'fas fa-eye-slash'
                    "></i>
                </button>
              </div>
              <!-- @if( signInForm.get('reEnterPassword')?.invalid &&
              signInForm.get('reEnterPassword')?.touched){
              <span class="error-text">Enter valid password</span>
              } -->
              @if( signInForm.get('password')?.value !=
              signInForm.get('reEnterPassword')?.value){
              <span class="error-text">Both passwords not matching</span>
              }
            </div>
          </div>
          <div class="password-rules-div">

            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image':  !pwdvalidation.lengthCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <span class="password-span">Length: 8–15 characters</span>
            </div>

            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image': !pwdvalidation.nameCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <span class="password-span">Must not contain your First Name or Last Name or Satsang</span>
            </div>
            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image': !pwdvalidation.emailCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <span class="password-span">Must not contain your Email Id</span>
            </div>
            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image': !pwdvalidation.consecutiveValueCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <span class="password-span">Must not contain three consecutive letters or numbers (e.g., ABC, 123)</span>
            </div>
            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image': !pwdvalidation.characterCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <div>
                <span class="password-span">Must contain at least:</span>
                <ul style="margin:0">
                  <li class="password-span">One uppercase letter (A-Z)
                  </li>
                  <li class="password-span">One lowercase letter (a-z)</li>
                  <li class="password-span">One number (0-9)</li>
                  <li class="password-span">
                    One special character from the set: <span [innerHTML]="specialChars"></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--2 input boxex-->
          <div class="row">
            <div class="col-12 col-md-12">
              <div class="input-field-container">
                <span class="input-level-text">Address *</span>
                <input type="text" class="input-field dp-input-control" placeholder="Enter your address"
                  formControlName="address" (keydown)="restrictAddressInput($event)" />
              </div>
              @if( signInForm.get('address')?.invalid&&
              signInForm.get('address')?.touched){
              <span class="error-text">Enter address</span>
              }
            </div>
          </div>
          <!--2 input boxex-->
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">Role Type</span>
                <!-- <input
                  type="text"
                  class="input-field dp-input-control"
                  placeholder="Enter your first name"
                  formControlName="roleName"
                  readonly
                /> -->
                <select class="input-field dp-input-control role-dropDown" formControlName="roleName">
                  <option value="Field Worker">Field Worker</option>
                  <option value="Mandir Worker">Mandir Worker</option>
                </select>
              </div>
              @if( signInForm.get('roleName')?.invalid &&
              signInForm.get('roleName')?.touched ){
              <span class="error-text">Enter role type</span>
              }
            </div>
            <div class="col-12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">PIN code *</span>
                <input type="text" (keyup)="onEnteringPincode()" class="input-field dp-input-control"
                  placeholder="Enter your PIN code" formControlName="pinCode" minlength="6" maxlength="6" />
              </div>
              @if( signInForm.get('pinCode')?.invalid &&
              signInForm.get('pinCode')?.touched){
              <span class="error-text">Enter pincode</span>
              }
            </div>
          </div>
          <!--2 input boxex-->
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="input-field-container d-flex flex-column">
                <span class="input-level-text" style="margin-bottom: 9px">State *</span>
                @if(stateList.length <=1){
                <input type="text" class="input-field dp-input-control" placeholder="Enter your state"
                  formControlName="stateName" />
                }@else{
                   <mat-form-field class="select-mat-form-field">
                  <mat-select name="state" id="state" formControlName="stateName"
                    placeholder="Select State" (selectionChange)="getDistrict($event)">
                    <mat-option *ngFor="let item of stateList" [value]="item">{{ item }}</mat-option>
                  </mat-select>
                </mat-form-field>
                }

                @if( signInForm.get('stateName')?.invalid &&
                signInForm.get('stateName')?.touched){
                <span class="error-text">Choose state </span>
                }
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="input-field-container d-flex flex-column">
                <span class="input-level-text" style="margin-bottom: 9px">District *</span>
                @if(districtName.length <= 1){
                <input type="text" class="input-field dp-input-control" placeholder="Enter your district"
                  formControlName="districtName" />
                }@else{
                   <mat-form-field class="select-mat-form-field">
                  <mat-select name="district" id="district" formControlName="districtName"
                    placeholder="Select District">
                    <mat-option *ngFor="let dist of districtName" [value]="dist">{{ dist }}</mat-option>
                  </mat-select>
                </mat-form-field>
                }
                @if( signInForm.get('districtName')?.invalid &&
                signInForm.get('districtName')?.touched){
                <span class="error-text">Choose district </span>
                }
              </div>
            </div>

            <!-- <div class="col-12 col-md-6" *ngIf="districtName.length > 1">
              <div class="input-field-container d-flex flex-column">
                <span class="input-level-text" style="margin-bottom: 9px">District</span>
                <mat-form-field class="select-mat-form-field">
                  <mat-select name="district" id="district" formControlName="districtName"
                    placeholder="Select District">
                    <mat-option *ngFor="let dist of districtName" [value]="dist">{{ dist }}</mat-option>
                  </mat-select>
                </mat-form-field>

                @if( signInForm.get('district_name')?.invalid &&
                signInForm.get('district_name')?.touched){
                <span class="error-text">Choose district</span>
                }
              </div>
            </div> -->
          </div>

          <button class="signIn-button dp-primary-btn" type="submit" (click)="goToVerification()">
            Sign up
          </button>

          <!-- <div class="input-field-container">
            <span class="input-level-text">Password*</span>
            <div class="password-container">
              <input
                [type]="passwordVisible ? 'text' : 'password'"
                class="input-field dp-input-control"
                placeholder="Enter your password"
                formControlName="password"
                (keyup)="onInputBlur('password')"
                (blur)="onInputBlur('password')"
              />
              @if (loginForm.get('password')?.value) {
              <div
                class="password-icon"
                [ngStyle]="{
                  'background-image': passwordVisible
                    ? 'var(' + visibilityOnIcon + ')'
                    : 'var(' + visibilityOffIcon + ')'
                }"
                (click)="togglePasswordVisibility()"
              ></div>
              }
            </div>
            @if (passwordInvalid) {
            <span class="error-message"> Enter a valid password </span>
            }
          </div>-->
        </form>
      </div>
    </div>
    <div class="footer-section">
      <div class="registration-ask-text">Already registered with DP Works?</div>
      <a class="registration-now-text" (click)="goToLogin()">Login now</a>
    </div>
  </div>
</div>